import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';

const PostBannerContainer = styled.div`
    .post-banner-wrapper {
        ${media.medium`max-width: 82.5vw;`}

        .image-container {
            position: relative;
            /* this has to be same as .content-container */
            margin-bottom: 15vh;
            .gatsby-image-wrapper {
                max-height: 60vh;
            }

            .content-container {
                position: absolute;
                bottom: -10vh;
                left: 0;
                width: 100%;
                .inner-wrap {
                    max-width: 60vw;
                    background-color: #f2f0eb;
                    box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.12);
                    padding: 30px;
                    margin: 0 auto;

                    .title-container {
                        a {
                            color: #fff;
                            background-color: #f74d33;
                            box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.25);
                            border-radius: 25px;
                            display: inline-block;
                            max-width: 200px;
                            width: 100%;
                            padding: 7px 0;
                            text-decoration: none;
                            text-align: center;
                            margin-bottom: 30px;

                            &.blog-branded {
                                background-color: #ff9905;
                            }
                            &.blog-wedding {
                                background-color: #13a6ab;
                            }
                            &.blog-impact {
                                background-color: #78781f;
                            }
                            &.blog-products-and-design {
                                background-color: #f74d33;
                            }
                        }
                        h1 {
                            font-weight: 800;
                            font-family: neue-kabel, sans-serif;
                            color: #0f1212;
                            margin: 0 0 20px;
                        }

                        p {
                            margin-bottom: 0px;
                            font-size: 0.9rem;
                        }
                    }
                }
            }
        }
    }
`;

const PostBanner = ({ image, post }) => {
    const { title, categories, date } = post || {};
    return (
        <PostBannerContainer>
            <Wrapper className="post-banner-wrapper">
                <div className="image-container">
                    <Img fluid={image} />

                    <div className="content-container">
                        <div className="inner-wrap">
                            <div className="title-container">
                                <Link
                                    to={`/blog/${categories.nodes[0].slug.replace(
                                        'blog-',
                                        ''
                                    )}`}
                                    className={categories.nodes[0].slug}
                                >
                                    {categories.nodes[0].name}
                                </Link>
                                <h1>{title}</h1>
                                <p>By Sam Davidoff. {date}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </PostBannerContainer>
    );
};

export default PostBanner;
